import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainPointsSection } from '../components/PainPointsSection';
import { WhatsInsideSection } from '../components/WhatsInsideSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { VisualSystemSection } from '../components/VisualSystemSection';
import { BuyBoxSection } from '../components/BuyBoxSection';
import { BonusesSection } from '../components/BonusesSection';
import { ReviewsSection } from '../components/ReviewsSection';
import { FAQSection } from '../components/FAQSection';
import { StickyFooter } from '../components/StickyFooter';
export function LandingPage() {
  return <main className="min-h-screen bg-white" data-id="element-234">
      <HeroSection data-id="element-235" />
      <PainPointsSection data-id="element-236" />
      <WhatsInsideSection data-id="element-237" />
      <VisualSystemSection data-id="element-238" />
      <BenefitsSection data-id="element-239" />
      <BuyBoxSection data-id="element-240" />
      <BonusesSection data-id="element-241" />
      <ReviewsSection data-id="element-242" />
      <FAQSection data-id="element-243" />

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8 px-4 text-center" data-id="element-244">
        <div className="max-w-4xl mx-auto" data-id="element-245">
          <p className="font-bold text-lg mb-3" data-id="element-246">MegaKit Lectura Feliz</p>
          <p className="text-gray-400 text-sm mb-6" data-id="element-247">
            Ayudando a miles de niños a descubrir el amor por la lectura.
          </p>
          <div className="text-xs text-gray-600" data-id="element-248">
            &copy; {new Date().getFullYear()} MegaKit Lectura Feliz. Todos los
            derechos reservados.
            <div className="mt-2 space-x-4" data-id="element-249">
              <a href="#" className="hover:text-white transition" data-id="element-250">
                Términos
              </a>
              <a href="#" className="hover:text-white transition" data-id="element-251">
                Privacidad
              </a>
              <a href="#" className="hover:text-white transition" data-id="element-252">
                Contacto
              </a>
            </div>
          </div>
        </div>
      </footer>

      <StickyFooter data-id="element-253" />
    </main>;
}